<template>
    <div class="must-have-exactly-one-root-element">

        <!-- Header -->
        <header-profil
            @updateProfil="emitUpdateProfil"
            :profil="profil"
        />

        <!-- Main -->
        <main class="profileDashboard">
            <div class="container">
                <div class="row">

                    <!-- Menu -->
                    <menu-profil
                        :profil="profil"
                        :spravy="spravy"
                    />

                    <!-- Heslo -->
                    <div v-if="profil.pouzivatel_id" class="col-xs-12 col-md-12 col-lg-8 col-xl-9">
                        <h2>Zmena hesla</h2>

                        <!-- Alert box -->
                        <div v-if="responseText != ''" :class="'alert alert-'+responseType" role="alert">
                            <span :class="'icon --'+responseType"></span>{{ responseText }}
                        </div>              

                        <!-- Form Box -->
                        <form @submit="formSubmit">
                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <label>Staré heslo</label>
                                    <input type="password" class="form-control" v-model="stare_heslo">
                                </div>   
                                <div class="col-xs-12 col-md-6"></div>                         
                            </div>

                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <label>Nové heslo</label>
                                    <input type="password" class="form-control" v-model="nove_heslo">
                                </div>
                                <div class="col-xs-12 col-md-6"></div>
                            </div>

                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <label>Zopakovať nové heslo</label>
                                    <input type="password" class="form-control" v-model="zopakovat_heslo">
                                </div>
                                <div class="col-xs-12 col-md-6"></div>
                            </div>

                            <div class="form-row">
                                <div class="col-xs-12 col-md-6">
                                    <button type="submit" class="btn --primary">Potvrdiť nové heslo <span class="icon"></span></button>
                                </div>
                            </div>
                        </form>
                        <!-- .Form Box -->
                    </div>
                    <!-- .Heslo -->

                </div>
            </div>
        </main>

    </div>
</template>



<script>
    import EventService from '@/services/EventService.js'
    import HeaderProfil from '../partials/HeaderProfil.vue'
    import MenuProfil   from '../partials/MenuProfil.vue'
    export default {
        components: {
            HeaderProfil,
            MenuProfil
        },
        props: [
            'profil',
            'spravy'
        ],
        mounted() {
        },
        data() {
            return {
                stare_heslo: '',
                nove_heslo: '',
                zopakovat_heslo: '',

                responseType: '',
                responseText: ''
            }
        },
        methods: {
            // emit
            emitUpdateProfil() {
                this.$emit('updateProfil')
            },


            // submit
            formSubmit(e) {
                e.preventDefault()
                this.changePassword()
            },

            changePassword() {
                if (this.nove_heslo == this.zopakovat_heslo) {
                    // https://www.npmjs.com/package/password-hash - ak by sa to muselo hashovať tu

                    //var enc = openssl_encrypt(this.stare_heslo, "AES-128-ECB", "adoptCow")
                    //this.stare_heslo = base64_encode(enc)

                    EventService.changePassword(this.stare_heslo, this.nove_heslo)
                        .then(response => {
                            //console.log(response.data)
                            this.responseType = response.data.code
                            this.responseText = response.data.data
                        })
                        .catch(error => {
                            this.responseType = 'warning'
                            this.responseText = error
                        })

                } else {
                    this.responseType = 'danger'
                    this.responseText = 'Heslá sa nezhodujú'
                }
            }
        }
    }
</script>